import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { countryListMapping } from '../../../assets/data/enum/countryListMapping';

@Injectable()
export class CitiesService {
  constructor() {}

  loadCountries(): Observable<any[]> {
    // Utilizza of per convertire countryListMapping in un Observable
    return of(countryListMapping);
  }
}
